<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(orario.id != null ? 'Dettaglio orario #' + orario.id + ' per impianto #' + orario.id_scheda : 'Nuovo orario per impianto #' + orario.id_scheda)">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="impianto">Impianto:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.nominativoscheda" id="impianto" type="text" disabled></b-form-input>                                    
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="tipo">Tipo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="orario.tipo" :options="options_tipi" disabled>
                                    
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="tipo">Descrizione:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.descrizione" id="descrizione" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="orainizio">Ora inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.orainizio" id="orainizio" type="time"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="orafine">Ora fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.orafine" id="orafine" type="time"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.datainizio" id="datainizio" type="date"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.datafine" id="datafine" type="date"></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row  class="my-1">
                            <b-col sm="3"><label for="giorno">Giorno:</label></b-col>
                            <b-col sm="9">
                                 <b-form-select v-model="orario.giorno" :options="options_giorno" id="giorno">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="prenotabilita">Prenotabilità:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="orario.prenotabilita" :options="options_prenotabilita" id="prenotabilita">
                                    <template slot="first">
                                        <!-- this slot appears above the options from 'options' prop -->
                                        <option :value="null" disabled>-- Seleziona --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagsta">Attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="orario.flagsta" :options="options_attivo" id="flagsta">

                                </b-form-select>
                            </b-col>
                        </b-row>
                        <b-row class="my-1" v-if="orario.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="orario.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="orario.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="orario.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>   

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    Prenotabilità,
    Categoria,
    Orario
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            orario: {
                id: this.$route.params.id || null,
                id_scheda: this.$route.params.id_scheda || null,
                tipo: this.$route.params.tipo || null,                
                nominativoscheda: '',
                orainizio: '00:00',
                orafine: '23:59',
                datainizio: '',
                datafine: '',
                giorno: null,
                prenotabilita: '',
                descrizione: '',
                flagsta: 'S',
                datains: null,
                uteins: ''
            },  
            parametri: null,                  
            error: '',
            options_prenotabilita: [], 
            options_giorno: [],   
            options_tipi: [],
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],          
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0              
        };
    },    
    computed:{
        socioVis: {
            // getter
            get: function () {
                if(this.abbonamento.id_socio == null || this.abbonamento.id_socio == 'null' || parseInt(this.abbonamento.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.abbonamento.cognomesocio + " " + this.abbonamento.nomesocio + " - " + this.abbonamento.accountsocio;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        }
    },
    methods: {              
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        getTipi() {

            var cat = new Categoria();
            var tipi = cat.getListaTipi();
            var keys = Object.keys(tipi);
            var options = [];
            for (var i = 0; i < keys.length; i++) {
                options.push({
                    value: keys[i],
                    text: tipi[keys[i]]
                });
            }

            return options;

            //return Object.assign({}, cat.getListaTipi());

        },
        insert() {
            var appdettaglio = this;
            
            if (this.orario.prenotabilita == "" || this.orario.prenotabilita == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Selezionare la prenotabilità!";               
            
            } else if (this.orario.datafine < this.orario.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";      
            } else {
                
                var json = JSON.stringify(this.orario);                

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/orario', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.orario = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/dettaglioorario/' + this.orario.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }

                            } else {
                                throw new Error(response.data.message);
                            }

                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });
            }

        }
    },
    created: function () {

        if(!ctrlVismenu("I")){
            this.$router.replace('/accessdenied');
            return;
        }

        var id = this.orario.id; //se è la prima volta si prova a prendere da getid 
        
        var tipo = this.orario.tipo;

        var token = localStorage.getItem('token');

        //creo la tendina prenotabilità
        var prenotabilità = new Prenotabilità();
        var options_pre = [];
        for (var i = 0; i < Object.keys(prenotabilità.getListaTipi()).length; i++) {
            options_pre.push({
                value: Object.keys(prenotabilità.getListaTipi())[i],
                text: prenotabilità.getTipoByFlag(Object.keys(prenotabilità.getListaTipi())[i])
            });
        }
        this.options_prenotabilita = options_pre;

        //creo la lista dei giorni
        var orario = new Orario();
        var options_gio = [];
        Object.keys(orario.getGiorniSettimana()).forEach(function(item){
            options_gio.push({
                value: (item == "null" ? null : item),
                text: orario.getGiornoSettimanaByNumero(item)
            });
        });
        //metto il campo vuoto che viene per ultimo per primo
        var orarioAux = options_gio.pop(); //tolgo l'ultimo
        options_gio.unshift(orarioAux); //lo metto in prima posizione
        this.options_giorno = options_gio;



        this.options_tipi = this.getTipi();

        var appdettaglio = this;

        if (id != null) {
            
            

            this.axios.get(NAMESPACE + 'rest/orari/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                
                                if (this.$route.params.duplica == 'true') {
                                    res[0].id = null;
                                }

                                appdettaglio.orario = res[0];                                
                                appdettaglio.showdettaglio = true;

                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }
        else{
            var id_scheda = this.orario.id_scheda;
            //chiamo il servizio che mi restituisce l'impianto
            this.axios.get(NAMESPACE + 'rest/impianti/' + this.orario.id_scheda, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {

                                    this.orario.nominativoscheda = res[0].nominativo;                                

                                } else {
                                    throw new Error("Errore evento non trovato!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });  
        }

        token = localStorage.getItem('token');

        //PAREMETRI
        this.axios.get(NAMESPACE + 'rest/cral', {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        var res = response.data.message;
                        //alert("Ret: " + JSON.stringify(res))
                        if (typeof res == "object") {

                            appdettaglio.parametri = res;

                            if(appdettaglio.parametri != null && appdettaglio.parametri.labelorarinessuno != ''){

                                appdettaglio.options_prenotabilita.forEach(function(item){

                                    if(item.text == "Nessuno"){
                                        item.text = appdettaglio.parametri.labelorarinessuno;
                                    }
                                });                                

                            }

                        } else {
                            throw new Error("Errore parametri non trovati!");
                        }


                    } else {
                        throw new Error(response.data.message);
                    }


                } catch (e) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                appdettaglio.showerror = true;
                appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });
                 

    },
    mounted: function() { 
        
    }

}
</script>
